import dayjs, { Dayjs } from 'dayjs';
import { useState, useEffect } from 'react';
import { useLocation } from 'react-router';
import { StyledDatePicker } from '../ActionPlan.styles';

export interface IDueDatePicker {
  disabled: boolean;
  date: Dayjs | null;
  setDate: (date: Dayjs) => void;
}

export const DueDatePicker = ({ disabled, date, setDate }: IDueDatePicker) => {
  const [isError, setIsError] = useState(false);
  const { pathname } = useLocation();
  const maxDate = dayjs().add(2, 'year');

  useEffect(() => {
    setIsError(dayjs().subtract(1, 'day').isAfter(date));
  }, [date]);

  return (
    <StyledDatePicker
      disabled={disabled}
      onChange={(e) => setDate(e)}
      isError={!pathname.includes('completed') && isError}
      value={date}
      disablePast
      format={'MMM-DD-YYYY'}
      maxDate={maxDate}
      minDate={dayjs()}
      slotProps={{
        openPickerButton: { color: 'primary' },
        inputAdornment: { position: 'start' },
        textField: {
          variant: 'standard',
          error: isError,
          placeholder: 'MMM-DD-YYYY',
        },
      }}
    />
  );
};
